import React from 'react';
import clsx from 'clsx';

import './index.scss';

import RadioInput from 'components/atoms/Input/RadioInput';
import RequiredOrOptionalIcon from 'components/atoms/Icon/RequiredOrOptionalIcon';
import TextAreaInput from 'components/atoms/Input/TextAreaInput';
import PcErrorArea from 'components/molecules/PcErrorArea';

const SpAccordionRadioTextArea = ({
  // radio
  id,
  value,
  checked,
  label,
  RadioOnChange,
  // textarea
  name,
  textAreaValue,
  cmntOnChange,
  onInput,
  onCompositionEnd,
  maxLength,
  placeholder,
  rows,
  cols,
  inValid,
  errPosition,
  errMessage,
  // 文字数
  wordCount,
}) =>{
  return(
    <div className="SpAccordionRadioTextArea">
      <div className="sp-accordion-radio-text-area-wrapper">
        <RadioInput
          id={id}
          value={value}
          checked={checked} 
          label={label} 
          onChange={RadioOnChange}
        />
        <div className={clsx('sp-cmnt-area', { checked })}>
          <div className="arrowArea">
            <div className="sp-background-cmnt" />
          </div>
          <div className="spCollpseAreaBackground">
            <div>
              ご検討の職種を記載してください
              <RequiredOrOptionalIcon label='任意' />
            </div>
            <TextAreaInput
              name={name}
              value={textAreaValue}
              onChange={cmntOnChange}
              onInput={onInput}
              onCompositionEnd={onCompositionEnd}
              maxLength={maxLength}
              placeholder={placeholder}
              rows={rows}
              cols={cols}
              inValid={inValid}
            />
            <div className='word-count'>{wordCount}</div>
            <span className='errArea'>
              <PcErrorArea position={errPosition} message={errMessage} />              
            </span>
          </div>
        </div>
      </div>
    </div>

  );
};

export default SpAccordionRadioTextArea;